import React from "react";
import LogoMark from "./LogoMark";
import HeroBanner from "../assets/images/bg-code.jpg";

const Hero = ({ onExplore, onStart }) => {
  return (
    <section id="hero">
      <div className="hero-left">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.8rem",
            fontSize: "0.75rem",
            fontWeight: 700,
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            color: "var(--accent)",
            marginBottom: "1rem",
          }}
        >
          <span
            style={{ width: 32, height: 2, background: "var(--accent)" }}
          ></span>{" "}
          Inspired Business Solutions
        </div>
        <h1
          style={{
            fontSize: "clamp(2rem, 10vw, 4rem)",
            fontWeight: 400,
            lineHeight: 1.1,
            letterSpacing: "0.02em",
            textTransform: "uppercase",
          }}
        >
          <span style={{ color: "var(--accent)" }}>Precision-</span>
          <br />
          Engineered
          <br />
          <span style={{ color: "var(--blue)" }}>Digital</span>
          <br />
          Solutions
        </h1>
        <p
          style={{
            marginTop: "1.5rem",
            fontSize: "1rem",
            fontWeight: 300,
            color: "var(--muted)",
            lineHeight: 1.6,
          }}
        >
          We partner with South African businesses to build powerful digital
          platforms, grow their online presence, and make smarter data-driven
          decisions - all backed by a team of specialists committed to your
          success.
        </p>
        <div
          style={{
            marginTop: "2rem",
            display: "flex",
            gap: "0.8rem",
            flexWrap: "wrap",
          }}
        >
          <button onClick={onExplore} className="btn-primary">
            Explore Services
          </button>
          <button onClick={onStart} className="btn-secondary">
            Request Free Consult
          </button>
        </div>
        <div className="hero-stats">
          <div>
            <div className="stat-num">
              50<span style={{ color: "var(--accent)" }}>+</span>
            </div>
            <div
              className="stat-label"
              style={{
                fontSize: "0.65rem",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                color: "var(--muted)",
              }}
            >
              Projects Delivered
            </div>
          </div>
          <div>
            <div className="stat-num">
              98<span style={{ color: "var(--accent)" }}>%</span>
            </div>
            <div className="stat-label">Client Retention</div>
          </div>
          <div>
            <div className="stat-num">6</div>
            <div className="stat-label">Core Services</div>
          </div>
        </div>
      </div>
      <div
        className="hero-right"
        style={{
          position: "relative",
          overflow: "hidden",
          background: `var(--dark) url(${HeroBanner}) no-repeat`,
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage:
              "linear-gradient(rgba(255,255,255,.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.04) 1px, transparent 1px)",
            backgroundSize: "48px 48px",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ animation: "float 5s ease-in-out infinite" }}>
            <LogoMark
              width={180}
              height={190}
              red="#c1c1c1"
              yellow="#f1f1f1"
              blue="#e1e1e1"
              orange="#616161"
            />
          </div>
        </div>
      </div>
      <style>{`
        @keyframes float { 0%,100% { transform: translateY(0px); } 50% { transform: translateY(-14px); } }
      `}</style>
    </section>
  );
};

export default Hero;
